function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const colors = {
  readOnly: "bg-gray-200",
};

const fmtCurrency = (value) => {
  return value.toLocaleString("es", { useGrouping: true });
};

const theme = {
  colors: {
    primary: "blue-200",
    secondary: "rose-200",
  },
  button: {
    margin: "mx-3",
    font: "font-bold",
    text: "text-white text-base",
    // color: "bg-indigo-400",
    // mouse: "pointer",
  },
  border:
    "border border-neutral-300 rounded-lg focus:border-cyan-500 outline-none",
  textSize: "text-sm",
  textColor: "text-neutral-700",
  textLabelColor: "text-neutral-500",
  textLabelColorDark: "text-neutral-100",
  input: {
    height: "h-10 lg:h-9.5 2xl:h-10",
    text: "text-sm lg:text-base xl:text-lg",
    iconSize: "w-5 h-5 lg:w-5 lg:h-5",
  },
  // Add more theme tokens like fonts, spacing, etc.
};

const buttonColors = {
  blue: "from-blue-400 to-cyan-500 text-white border-none",
  yellow: "bg-amber-400 text-neutral-900 border-none",
  sky: "bg-sky-400 text-white border-none",
  amber: "bg-[#FFCC00] hover:bg-[#FFD633] text-gray-900 disabled:bg-[#FFF4CC]",
  green: "bg-green-300 text-green-800 border-none",
  indigo: "from-indigo-400 to-violet-500 text-white border-none",
  pink: "from-pink-500 to-pink-600 text-white border-none",
  rose: "bg-rose-400 text-rose-100",
  slate: "from-slate-500 to-slate-600 text-white border-none",
  neutralDark: "bg-neutral-800 text-white border-none",
  neutralLight: "bg-neutral-200 text-neutral-900 border-none",
  black: "bg-black text-white border-none",
  yellowPresik: "bg-yellow-500 text-blue-800",
  gray: "bg-gray-200 text-gray-900 border-none",
};

const buttonOutlineColors = {
  rose: "bg-transparent border-rose-500 text-rose-600 hover:bg-rose-500 hover:text-white transition duration-300",
  blue: "bg-transparent border-blue-500 text-blue-800 hover:bg-blue-500 hover:text-white transition duration-300",
  lime: "bg-transparent border-lime-500 text-lime-800 hover:bg-lime-500 hover:text-white transition duration-300",
  amber:
    "bg-transparent border-amber-500 text-amber-600 hover:bg-amber-500 hover:text-white transition duration-300",
  neutralDark:
    "bg-transparent border-neutral-800 text-neutral-900 hover:bg-neutral-800 hover:text-white transition duration-300",
};

export {
  theme,
  classNames,
  colors,
  fmtCurrency,
  buttonColors,
  buttonOutlineColors,
};
